export const API_URL = {
     local: {
          stage: "http://localhost:4004",
          'dev/event': "http://localhost:4004",
          evnts: "http://localhost:4004",
          users: "http://localhost:4004",
          bookings: "http://localhost:4004",
     },
     dev: "https://api.tikitly.com",
     prod: "https://api.tikitly.com",
     cron: "https://api-gen.bookzy.app",
};

/**
 * Ticket-shop base URL.
 *
 * Single source of truth is REACT_APP_WEBAPP_EVENT_URL (.env.development /
 * .env.production), which is also what EventDetails.js reads — so booking links,
 * ticket downloads and on-site product QR codes can never drift apart.
 *
 * The fallbacks below only apply if that variable is missing at build time.
 */
const WEBSHOP_URL_FALLBACK = {
     local: "https://devshop.tikitly.com",
     dev: "https://devshop.tikitly.com",
     prod: "https://shop.tikitly.com",
};

export const CURRENT_ENV = process.env?.REACT_APP_APP_ENV || "dev";
// export const CURRENT_ENV = "local";

export const getUrlForModule = (modulePath, forwardSlash = true) => {
     if (CURRENT_ENV == 'local') {
          return `${API_URL[CURRENT_ENV][modulePath]}/dev${forwardSlash ? `/` : ``}`
     }
     // return `${API_URL[CURRENT_ENV]}/${modulePath}${forwardSlash ? `/` : ``}`
     return `${API_URL[CURRENT_ENV]}/${CURRENT_ENV}${forwardSlash ? `/` : ``}`
}

export const getUrlForStage = () => {
     return getUrlForModule(CURRENT_ENV)
}

export const getUrlForEvent = () => {
     return getUrlForModule(`evnts`)
}

export const getUrlForUsers = () => {
     return getUrlForModule(`users`)
}

export const getUrlForClasses = (path = 'schools') => {
     return getUrlForModule(`${CURRENT_ENV || 'dev'}${path !== "" ? "/" + path : ""}`)
}

export const getUrlForServices = () => {
     return getUrlForModule(`services`)
}

export const getUrlForBookings = () => {
     return getUrlForModule(`bookings`)
}

export const getUrlForFoods = () => {
     return getUrlForModule(`foods`)
}

export const getUrlForCronServer = () => {
     return `${API_URL['cron']}/${CURRENT_ENV}/`
}

/**
 * Ticket-shop base URL, always with exactly one trailing slash so callers can append
 * a path directly (e.g. `${getWebshopUrlForEvent()}get-ticket/${token}`).
 *
 * NOTE: product QR codes do NOT use this — the backend returns `product.onsiteSaleUrl`
 * derived from BOOKING_LINK, so there is one source of truth for that URL.
 */
export const getWebshopUrlForEvent = () => {
     const configured = process.env.REACT_APP_WEBAPP_EVENT_URL;
     const base = configured && configured.trim() !== ""
          ? configured
          : (WEBSHOP_URL_FALLBACK[CURRENT_ENV] || WEBSHOP_URL_FALLBACK.prod);
     return `${String(base).replace(/\/+$/, "")}/`
}

